import { Box, Container, Grid, IconButton, MenuItem, Select, SelectChangeEvent, Tab, Tabs, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { IoReloadCircle } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import ReceptorService from "../../services/ReceptorService";
import { PaginateObj } from "../../types/Paginate/PaginateObjt";
import { AnunciosData } from "../../types/Anuncio/AnuncioData";
import { CardAnuncio } from "../../componente/Anuncio/CardAnuncio";
import { BarraBusqueda } from "../../common/Behelit/BarraBusqueda";
import { themePalette } from "../../config/theme.config";
import { Categoria } from "../../types/Categoria/Categoria";
import CategoriasService from "../../services/CategoriasService";
import { CenterBox } from "../../common/Behelit/CenterBox";
import { Cookies } from "typescript-cookie";
import { useIsAuthenticated } from "@azure/msal-react";

export const GeneralPage: React.FC<{}> = () => {
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [pageData, setPageData] = useState<PaginateObj<AnunciosData>>();
    const [anuncios, setAnuncios] = useState<Array<AnunciosData>>([]);
    const [categorias, setCategorias] = useState<Array<Categoria>>([]);
    const [categoria, setCategoria] = useState(0);
    const [tab, setTab] = useState(0);
    const [search, setSearch] = useState('');
    const [cookieDetectada, setCookieDetectada] = useState(false);
    //region function
    const getCategorias = async () => {
        await CategoriasService.GetCategoriasActivas().then((data) => {
            //console.log(data)
            if (data.status.isSuccessfully) {
                setCategorias(data.listData);
            }
        }).catch((error) => console.error(error));
    }
    const fetchAnunciosFree = async () => {
        setLoading(true)
        try {
            const response = await ReceptorService.GetAnuncios(categoria);
            const data = response;
            if (response.succeeded) {
                setPageData(data)
                setAnuncios(data.data)
                console.log(data.data)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const fetchAnunciosFreeByName = async () => {
        setLoading(true)
        try {
            const response = await ReceptorService.GetAnunciosByKeyWord(search, categoria);
            const data = response;
            if (response.succeeded) {
                setPageData(data)
                setAnuncios(data.data)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const fetchAnunciosPorVencer = async () => {
        setLoading(true)
        try {
            const response = await ReceptorService.GetAnunciosPorVencer(categoria);
            const data = response;
            //console.log(data);
            if (response.succeeded) {
                setPageData(data)
                setAnuncios(data.data)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const fetchAnunciosPorVenceByName = async () => {
        setLoading(true)
        try {
            const response = await ReceptorService.GetAnunciosPorVencerByKeyWork(search, categoria);
            const data = response;
            // console.log(data);
            if (response.succeeded) {
                setPageData(data)
                setAnuncios(data.data)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const feedAnuncios = (tab: number) => {
        switch (tab) {
            case 0:
                fetchAnunciosFree();
                break;
            case 1:
                fetchAnunciosPorVencer();
                break;
            default:
                fetchAnunciosFree();
                break;
        }
    }

    const feedAnunciosSearch = (tab: number) => {
        switch (tab) {
            case 0:
                fetchAnunciosFreeByName();
                break;
            case 1:
                fetchAnunciosPorVenceByName();
                break;
            default:
                fetchAnunciosFree();
                break;
        }
    }

    const loadMoreAnuncios = useCallback(async () => {
        if (loadingMore || !pageData) return;// evitar multiples llamadas
        setLoadingMore(true);
        try {
            if (pageData?.nextPage !== null) {
                const response = await ReceptorService.GetPage(pageData?.nextPage ?? '')
                const data = response;
                setPageData(data);
                //setAnuncios((prevAnuncios) => [...prevAnuncios, ...data.data])
                setAnuncios((prevAnuncios) => {
                    const newAnuncios = data.data;
                    // Filtrar los nuevos anuncios para que no se agreguen los repetidos por 'id'
                    const filteredNewAnuncios = newAnuncios.filter((newAnuncio) =>
                        !prevAnuncios.some((prevAnuncio) => prevAnuncio.idAnuncio === newAnuncio.idAnuncio)
                    );
                    // Devolver el estado actualizado con los anuncios no repetidos
                    return [...prevAnuncios, ...filteredNewAnuncios];
                });
            }
        } catch (error) {
            console.error("Error loading more: ", error);
        } finally {
            setTimeout(() => {
                setLoadingMore(false);
            }, 1000);
        }
    }, [loadingMore, pageData, anuncios]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    const handleSearchChange = (value: string) => {
        setSearch(value);
    };
    const handleCategoriaChange = (event: SelectChangeEvent<number>) => {
        setCategoria(Number(event.target.value)); // Asegurar conversión a número
    };
    //endregion
    //region useEffect
    useEffect(() => {
        getCategorias();
        fetchAnunciosFree();
    }, []);

    useEffect(() => {
        let cookieValorAnterior = Cookies.get("tokenEspolAds");

        const checkCookie = () => {
            const cookieValorActual = Cookies.get("tokenEspolAds");

            // Verificar si el valor de la cookie ha cambiado
            if (cookieValorActual !== cookieValorAnterior) {
                //console.log("La cookie ha cambiado:", cookieValorActual);
                fetchAnunciosFree();

                // Actualizar el valor anterior de la cookie
                cookieValorAnterior = cookieValorActual;

                // Marcar que ya se detectó el cambio
                setCookieDetectada(true);
            }
        };

        // Revisar cada 20 segundos si la cookie cambia
        const interval = setInterval(checkCookie, 1000);

        return () => {
            clearInterval(interval); // Limpiar el intervalo al desmontar
        };
    }, [cookieDetectada]);
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + document.documentElement.scrollTop;
            const threshold = document.documentElement.offsetHeight - 500;
            if (scrollPosition >= threshold) {
                loadMoreAnuncios();
            }
        };

        window.addEventListener("scroll", handleScroll);
        // Limpiar el evento cuando el componente se desmonte o se actualice
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [loadMoreAnuncios]);

    useEffect(() => {
        feedAnuncios(tab);
    }, [tab]);

    useEffect(() => {
        if (search.length === 0) {
            feedAnuncios(tab);
        }
        if (search.length < 3) return;
        const debounce = setTimeout(() => {
            feedAnunciosSearch(tab);
        }, 500)
        function cleanup() {
            clearTimeout(debounce)
        }
    }, [search, categoria])

    return (
        <Container maxWidth="lg" style={{ marginTop: 10, padding: '20px', textAlign: 'center', border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    PRINCIPAL
                </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="Pestañas interactivas"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Recientes" id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label="Por Vencer" id="tab-1" aria-controls="tabpanel-1" />
                </Tabs>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Grid container spacing={1}>
                    <Grid item sm={12} lg={4} >
                        <CenterBox customStyles={{ m: 1, width: '100%' }}>
                            <Select
                                labelId="select-categorias"
                                value={categoria}
                                onChange={handleCategoriaChange}
                                size="small"
                                sx={{ marginBottom: '20px', width: '100%' }}
                            >
                                <MenuItem value={0}>Todas las categorias</MenuItem>
                                {categorias.map((c) => (
                                    <MenuItem key={c.idCategoria} value={c.idCategoria}>
                                        {c.txNombreCategoria}
                                    </MenuItem>
                                ))
                                }
                            </Select>
                        </CenterBox>
                    </Grid>
                    <Grid item sm={12} lg={8}>
                        <BarraBusqueda id={"busqueda"} customStyles={{ m: 1, width: '100%' }} input={search} onChange={handleSearchChange} placeholder="Escriba una palabra clave relacionada con su búsqueda" />
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ display: 'flex' }}>
                {/* Contenido principal */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                    }}
                >
                    {loading ?
                        (<CircularProgress />)
                        : anuncios.length === 0 ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center', // Alinea el texto
                                    backgroundColor: themePalette.BGWHITE, // Fondo claro
                                }}
                            >
                                <Typography variant="h4" color="primary">
                                    Sin resultados
                                </Typography>
                            </Box>
                        ) : (
                            <Grid container spacing={2}>
                                {anuncios.map((anuncio, index) => (
                                    <Grid item key={`${anuncio.idAnuncio}-${index}`} xs={12} sm={6} md={3}>
                                        <CardAnuncio anuncio={anuncio} GoTo={`/ver-anuncio/${anuncio.idAnuncio}`} />
                                    </Grid>
                                ))
                                }
                            </Grid>
                        )
                    }
                </Box>
            </Box>
        </Container>
    )
}